/*
 * File: huddle-client.service.ts
 * Project: a-a
 * File Created: Thursday, 20th November 2025 9:44:49 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 17th June 2026 6:37:58 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import {
  ClientActivityQueryParams,
  ClientTaskQueryParams,
  ClientV2TypesResponse,
  CreateClientV2Payload,
} from '../model/client.model';
import { HuddleApiConstants } from './huddle-api-constants';

export class HuddleClientService {
  static getAllClient = async () => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.ALL_CLIENT.URL())
    ).data;
  };
  static getClientTypesV2 = async (): Promise<ClientV2TypesResponse> => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.CLIENT_TYPES_V2.URL())
    ).data;
  };
  static createClientV2 = async (payload: CreateClientV2Payload) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.CREATE_CLIENT_V2.URL(), payload)
    ).data;
  };
  static addHuddleClient = async (payload: any) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.ADD_CLIENT.URL(), payload)
    ).data;
  };
  static deleteHuddleClient = async (id: string) => {
    // console.log(data);
    return await (
      await axios.patch(HuddleApiConstants.CLIENT_API.ARCHIVE_CLIENT.URL(id))
    ).data;
  };
  static editHuddleClient = async (payload: any, id: string) => {
    // console.log(data);
    return await (
      await axios.patch(HuddleApiConstants.CLIENT_API.DELETE_EDIT_CLIENT.URL(id), payload)
    ).data;
  };
  static getClientHuddleDetails = async (id: string) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.CLIENT_DETAILS.URL(id))
    ).data;
  };
  static getHuddleClientDropdowns = async (id: string) => {
    // console.log(ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.CLIENT_DROPDOWNS.URL(id))
    ).data;
  };
  static getHuddleClientKeyDeals = async (id: string, query: any) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(
        HuddleApiConstants.CLIENT_API.CLIENT_KEY_DEALS.URL(id) +
          HuddleApiConstants.CLIENT_API.CLIENT_KEY_DEALS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static addHuddleDeal = async (payload: any) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.ADD_DEAL.URL(), payload)
    ).data;
  };
  static editHuddleDeal = async (id: string, payload: any) => {
    return await (
      await axios.patch(HuddleApiConstants.CLIENT_API.EDIT_DEAL.URL(id), payload)
    ).data;
  };
  static deleteHuddleDeal = async (id: string, data: any) => {
    // console.log(data);
    return await (
      await axios.delete(HuddleApiConstants.CLIENT_API.EDIT_DEAL.URL(id), data)
    ).data;
  };
  static getHuddleDealDropdown = async (id?: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.DEAL_DROPDOWN.URL(id))
    ).data;
  };
  static getHuddlePricebooks = async () => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.ALL_PRICEBOOKS.URL())
    ).data;
  };
  static getHuddlePricebookProducts = async (id: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.PRICEBOOK_PRODUCTS.URL(id))
    ).data;
  };
  static addHuddlePricebookProducts = async (payload: any) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.CREATE_PRICEBOOK_PRODUCTS.URL(), payload)
    ).data;
  };
  static editHuddlePricebookProducts = async (payload: any, id: string) => {
    return await (
      await axios.patch(HuddleApiConstants.CLIENT_API.EDIT_PRICEBOOK_PRODUCTS.URL(id), payload)
    ).data;
  };
  static getHuddleActivity = async (id: string, query: ClientActivityQueryParams) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(
        HuddleApiConstants.CLIENT_API.CLIENT_ACTIVITY.URL(id) +
          HuddleApiConstants.CLIENT_API.CLIENT_ACTIVITY.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getHuddleClientDeal = async (id: string) => {
    // console.log(ApiConstants.DASHBOARD_API.GET_ACTIVITY.QUERY_PARAMS());
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.CLIENT_DEAL.URL(id))
    ).data;
  };
  static getTasks = async (id: string, query: ClientTaskQueryParams) => {
    // console.log(ApiConstants.CLIENT_API.CLIENT_TASKS.QUERY_PARAMS(query));
    return await (
      await axios.get(
        HuddleApiConstants.CLIENT_API.GET_TASKS.URL(id) +
          HuddleApiConstants.CLIENT_API.GET_TASKS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getClientContacts = async (id: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.GET_CONTACTS.URL(id))
    ).data;
  };
  static postClientContact = async (payload: any) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.POST_CONTACT.URL(), payload)
    ).data;
  };
  static updateClientContact = async (payload: any, contactId: string) => {
    return await (
      await axios.patch(HuddleApiConstants.CLIENT_API.UPDATE_CONTACT.URL(contactId), payload)
    ).data;
  };
  static deleteClientContact = async (id: string) => {
    return await (
      await axios.delete(HuddleApiConstants.CLIENT_API.DELETE_CONTACT.URL(id))
    ).data;
  };
  static addClientEvent = async (payload: any, id: string) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.POST_CLIENT_EVENT.URL(id), payload)
    ).data;
  };
  static getClientEvents = async (id: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.GET_CLIENT_EVENTS.URL(id))
    ).data;
  };
  static getClientEventById = async (clientId: string, eventId: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.GET_CLIENT_EVENT_BY_ID.URL(clientId, eventId))
    ).data;
  };
  static editClientEvent = async (clientId: string, eventId: string, payload: any) => {
    return await (
      await axios.patch(
        HuddleApiConstants.CLIENT_API.EDIT_CLIENT_EVENT.URL(clientId, eventId),
        payload,
      )
    ).data;
  };
  static deleteClientEvent = async (clientId: string, eventId: string) => {
    return await (
      await axios.delete(HuddleApiConstants.CLIENT_API.DELETE_CLIENT_EVENT.URL(clientId, eventId))
    ).data;
  };
  static addUserEvent = async (payload: any) => {
    return await (
      await axios.post(HuddleApiConstants.CLIENT_API.POST_USER_EVENT.URL(), payload)
    ).data;
  };
  static getUserEvents = async () => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.GET_USER_EVENTS.URL())
    ).data;
  };
  static getUserEventById = async (eventId: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.GET_USER_EVENT_BY_ID.URL(eventId))
    ).data;
  };
  static editUserEvent = async (eventId: string, payload: any) => {
    return await (
      await axios.patch(HuddleApiConstants.CLIENT_API.EDIT_USER_EVENT.URL(eventId), payload)
    ).data;
  };
  static deleteUserEvent = async (eventId: string) => {
    return await (
      await axios.delete(HuddleApiConstants.CLIENT_API.DELETE_USER_EVENT.URL(eventId))
    ).data;
  };
  static getClientPriorities = async (clientId: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.CLIENT_PRIORITIES.URL(clientId))
    ).data;
  };
  static getClientV2Calendar = async (clientId: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.CLIENT_V2_CALENDAR.URL(clientId))
    ).data;
  };
  static getPresignedUrl = async (size: string, type: string, key: string) => {
    return await (
      await axios.get(HuddleApiConstants.CLIENT_API.GET_PRESIGNED_URL.URL(size, type, key))
    ).data;
  };
}
